// extracted by mini-css-extract-plugin
export default {"section":"CoachesSection_section__szurA"};